// Clears the browser's cached app assets (the usual cause of "stale bundle"
// glitches after a new deploy) and reloads. Deliberately does NOT touch
// localStorage — the active-registration selection and UI prefs are kept, and
// the auth session rides an httpOnly cookie, so the user stays logged in.
export async function clearAppCacheAndReload() {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch { /* ignore */ }
  try {
    if (navigator.serviceWorker) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch { /* ignore */ }
  // Cache-bust the document itself so the freshest index.html (and its hashed
  // bundles) is fetched.
  const url = new URL(window.location.href);
  url.searchParams.set("_r", Date.now().toString());
  window.location.replace(url.toString());
}
